import { memo } from "react";
import { useShallow } from "zustand/react/shallow";

import TableHead from "ds/components/Table/Head";
import { getHeadColumnKey } from "ds/components/Table/Head/helpers";
import TableHeadInteractiveColumn, {
  TableHeadInteractiveColumnProps,
} from "ds/components/Table/Head/InteractiveColumn";
import { selectVisibleColumns } from "ds/components/Table/store/useTableStore/selectors";
import { TableGenericStore } from "ds/components/Table/store/useTableStore/types";

type SpaceDetailsTableHeadProps = {
  store: TableGenericStore;
} & Pick<
  TableHeadInteractiveColumnProps,
  "tableRef" | "sortConfig" | "sortCallback" | "filtersStorageKey"
>;

const SpaceDetailsTableHead = ({
  store,
  tableRef,
  sortConfig,
  sortCallback,
  filtersStorageKey,
}: SpaceDetailsTableHeadProps) => {
  const columns = store(useShallow(selectVisibleColumns));

  return (
    <TableHead>
      {columns.map((column, i) => (
        <TableHeadInteractiveColumn
          key={getHeadColumnKey(column)}
          column={column}
          store={store}
          tableRef={tableRef}
          sortConfig={sortConfig}
          sortCallback={sortCallback}
          filtersStorageKey={filtersStorageKey}
          isLast={i === columns.length - 1}
        />
      ))}
    </TableHead>
  );
};

export default memo(SpaceDetailsTableHead);
